import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-04b6840d")

_pushScopeId("data-v-04b6840d")
const _hoisted_1 = { class: "segmented-slider-track" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    class: ["segmented-slider", { alternate: _ctx.alternate, disabled: _ctx.disabled }]
  }, [
    _createVNode("div", _hoisted_1, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.segments, (segment) => {
        return (_openBlock(), _createBlock("div", {
          key: segment.index,
          class: ["segmented-slider-segment", { active: segment.active }],
          style: segment.style
        }, null, 6))
      }), 128)),
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dots, (dot) => {
        return (_openBlock(), _createBlock("div", {
          key: dot.index,
          class: ["segmented-slider-dot", { active: dot.active }],
          style: dot.style
        }, null, 6))
      }), 128))
    ]),
    _createVNode("input", {
      class: "segmented-slider-input",
      type: "range",
      min: _ctx.min,
      max: _ctx.max,
      step: _ctx.step,
      value: _ctx.internalValue,
      disabled: _ctx.disabled,
      onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onInput && _ctx.onInput(...args)))
    }, null, 40, ["min", "max", "step", "value", "disabled"])
  ], 2))
})